// @flow

import { createSelector } from 'reselect';

import friendsSelector from './friendsSelector';

function getFriends(allFriends: Array<Friend | FriendRequest>, currentGroup: FriendGroup) {
  if (!currentGroup) {
    return [];
  }

  return allFriends.filter(friend => currentGroup.members.includes(friend.id));
}

const friendsInGroupSelector = createSelector(
  state => friendsSelector(state),
  (state, groupId) => state.friendGroups.groups[groupId],
  getFriends
);

export default friendsInGroupSelector;
